import { Injectable } from '@angular/core';
import { NativeAppService } from '@shared/common/services/native-app/native-app.service';
import { modalVars } from '../../../constants/modal-vars';
import { addClass, removeClass } from '../../../utils/toggle-class/toggle-class';

@Injectable({
  providedIn: 'root'
})
export class DrawerService {
  constructor(private readonly nativeAppService: NativeAppService) {}

  get isAnotherModalOpen(): boolean {
    return Object.values(modalVars).filter((x: boolean): boolean => x === true).length > 0;
  }

  open(modalId: string): void {
    modalVars[modalId] = true;
    addClass('lm-drawer-open', document.body);
    this.nativeAppService.notifyIntentToOpenBottomSheet(modalId);
  }

  close(modalId: string): void {
    modalVars[modalId] = false;
    if (!this.isAnotherModalOpen) {
      removeClass('lm-drawer-open', document.body);
    }
    this.nativeAppService.notifyIntentToCloseBottomSheet(modalId);
  }

  closeAllModals(): void {
    for (const modal in modalVars) {
      modalVars[modal] = false;
      this.nativeAppService.notifyIntentToCloseBottomSheet(modal);
    }
    removeClass('lm-drawer-open', document.body);
  }
}
